import { Component, ViewEncapsulation, OnInit } from '@angular/core';
import { AppSettings } from './app.settings';
import { Settings } from './app.settings.model';
import { NavigationHistoryService } from './navigation-history.service';
import { LoaderComponent } from './theme/loader/loader.component';
import { NgbTooltipConfig } from '@ng-bootstrap/ng-bootstrap';
import { MessageService } from './shared/messages/message.service';
import Swal from 'sweetalert2';
@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.scss'],
    encapsulation: ViewEncapsulation.None
})
export class AppComponent implements OnInit {
    public settings: Settings;
    loader: typeof LoaderComponent;

    constructor(public appSettings: AppSettings,
        private routingHistory: NavigationHistoryService,
        private config: NgbTooltipConfig,
        private messageService: MessageService
    ) {
        this.settings = this.appSettings.settings;
        this.routingHistory.loadRouting();
        this.loader = LoaderComponent;
        this.config.container = 'body';
    }

    ngOnInit() {
        // Carrega localmente o pdfWorker para evitar lentidão
        (<any>window).pdfWorkerSrc = './assets/js/pdf.worker.min.js';

        if (typeof window !== 'undefined' && typeof window['process'] !== 'undefined') {
            delete window['process'];
        }
 
    }
}
